module.exports = __webpack_public_path__ + "static/media/friargate-1.08ee2eb3.jpg";